import './registerServiceWorker'

import App from './App.vue'
import Notifications from 'vue-notification'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import VueI18n from 'vue-i18n'
import axios from './axios'
import mixin from './mixins/globalMixin'
import router from './router'
import store from './store'
import util from './util'
import validator from './plugins/validator'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.use(Notifications)
Vue.prototype.$liff = window.liff

const plugin = {
    install (Vue) {
        Vue.prototype.$util = util
        Vue.prototype.$validator = validator
    }
}
Vue.use(plugin)
Vue.use(VueI18n)
Vue.mixin(mixin)

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
